const names = [
  'tag_work_icon',
  'tag_work_briefcase_1_icon',
  'tag_weights_icon',
  'tag_sportwatch_icon',
  'tag_gym_icon',
  'tag_shopping_icon',
  'tag_shopping_basket_icon',
  'tag_party_icon',
  'tag_vacation_icon',
  'tag_transportation_water_icon',
  'tag_transportation_railway_icon',
  'tag_transportation_bus_icon',
  'tag_free_ride_icon',
  'tag_transportation_taxi_icon',
  'tag_road_icon',
  'tag_l17_icon'
]

export default { names }
